import React from 'react';

import { Surface, Button } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import classes from './GrossRevenueAnalyticsWidget.module.scss';
import { useGrossRevenueData } from './hooks/useGrossRevenueData';
import { GrossRevenueSummary } from './GrossRevenueSummary/GrossRevenueSummary';
import { GrossRevenueGraph } from './GrossRevenueGraph/GrossRevenueGraph';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

const GrossRevenueAnalyticsWidget = observer(() => {
  const { billingType } = loggedInUserDataStore;
  const { dateRangePreset, solutionTypeFilter, solutionTypeFilterFlags } =
    entityDashboardFilterStore;
  const { grossRevenueData } = useGrossRevenueData({
    dateRangePreset,
    solutionTypeFilter,
  });

  const isShowDetailedRevenueButton =
    solutionTypeFilterFlags.NUTRITION && billingType.AUTOMATED_BILLING;

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Gross Revenue Analytics"
        tooltipContent={
          <>
            Total nutrition revenue and/or ScanIQ revenue (gross)
            <br /> Stripe billing required
          </>
        }
        endAdornment={
          isShowDetailedRevenueButton && (
            <Button
              href="#!/detailed-revenue"
              target="_blank"
              variant="outlined"
              size="small"
            >
              Show Detailed Revenue
            </Button>
          )
        }
      />
      {grossRevenueData && (
        <div className={classes.content}>
          <GrossRevenueGraph grossRevenueGraphData={grossRevenueData.grossRevenueGraph} />
          <GrossRevenueSummary
            currentPeriodRevenue={grossRevenueData.currentPeriodRevenue}
            previousPeriodRevenue={grossRevenueData.previousPeriodRevenue}
          />
        </div>
      )}
    </Surface>
  );
});

export { GrossRevenueAnalyticsWidget };
